<template>
    <div>
        <b-navbar-nav>
            <b-nav-item-dropdown text="Belgeler">
                <b-nav-item v-if="kisi.yonetici" :to="{name: 'belgeler', query:{tur:'mektup'}}" exact-active-class="active" >
                    Tüm Mektuplar
                </b-nav-item>

                <b-nav-item v-if="kisi.mektupEditor || kisi.mektupOperator" :to="{name: 'belgeler',query:{ne:'sahsi', tur:'mektup'}}" exact-active-class="active">
                    Mektuplarım
                </b-nav-item>

                <b-nav-item v-if="kisi.yonetici" :to="{name: 'belgeler', query:{tur:'kart'}}" exact-active-class="active">
                    Tüm Kartlar
                </b-nav-item>

                <b-nav-item v-if="kisi.kartEditor || kisi.kartOperator" :to="{name: 'belgeler',query:{ne:'sahsi', tur:'kart'}}" exact-active-class="active">
                    Kartlarım
                </b-nav-item>
            </b-nav-item-dropdown>


            <b-nav-item-dropdown text="İste" right>
                <b-nav-item v-if="kisi.mektupOperator" v-on:click="belgeiste($event,'mektup')" exact-active-class="active">
                    Mektup
                </b-nav-item>
                <b-nav-item v-if="kisi.mektupEditor" v-on:click="belgeiste($event,'mektup',true)" exact-active-class="active">
                    Tashih için Mektup
                </b-nav-item>

                <b-nav-item v-if="kisi.kartOperator" v-on:click="belgeiste($event,'kart')" exact-active-class="active">
                    Kart
                </b-nav-item>
                <!--<b-nav-item v-if="kisi.kartEditor" v-on:click="belgeiste($event,'kart',true)" exact-active-class="active">
                    Tashih İçin Kart
                </b-nav-item>-->


            </b-nav-item-dropdown>

            <b-nav-item v-if="kisi.isim" :to="{name: 'okunamayankelimeler'}" exact-active-class="active">
                Okunamayan Kelimeler
                <b-badge pill variant="info">{{bkCount}}</b-badge>
            </b-nav-item>

            <b-nav-item v-if="kisi.yonetici" :to="{name: 'kisiler'}" exact-active-class="active">
                Kişiler
            </b-nav-item>
            
            <b-nav-item v-if="kisi.kartEditor" :to="{name: 'sorumluOlunanKisiler'}" exact-active-class="active">
                Sorumlu Olunan Kişiler
            </b-nav-item>
            
            <b-nav-item :to="{name: 'toplamHaftalikRapor'}" exact-active-class="active">
                Haftalık Toplam Rapor
            </b-nav-item>
            
            <b-nav-item @click="$router.push({path: 'yardım'})">
                Yardım
            </b-nav-item>

            <b-nav-item @click="latinceOsmanlicayaGit">
                İmla
            </b-nav-item>

            <b-nav-item @click="logout()">
                Çıkış
            </b-nav-item>
        </b-navbar-nav>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {iste} from "@/api/iste";
    import {CikisYap} from "@/api/kisi";

    export default {
        name: 'NavItems',
        props: ["mobilAnasayfaOzel"],
        methods: {
            async belgeiste(e, tur, tashihMi = false) {
                e.preventDefault();
                await iste(this, tur, tashihMi);
            },
            async logout() {
                const auth2 = await this.$gapi._libraryLoad('auth2');
                const GoogleAuth = await auth2.init(this.$gapi.config);
                await GoogleAuth.signOut();
                await this.$store.commit('reset');
                await CikisYap();
                await this.$router.push("/giris-yap?url=" + encodeURI("/"))
            },
            latinceOsmanlicayaGit() {
                let routeData = this.$router.resolve({name: 'latinceosmanlica'});
                window.open(routeData.href, '_blank');
            }
        },
        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'mektupMenusuGoster', 'kartMenusuGoster', 'mektupIsteGoster', 'kartIsteGoster'
            ])
        }
    }
</script>

<style lang="scss" scoped>
    /*.mobilAnasayfaOzel {
        .nav-link {
            color: cornflowerblue;
            font-weight: 900;
        }
        #cikisBtn {
            margin-left: 0px;
        }
    }*/
</style>
